import { render, staticRenderFns } from "./ReportCallRequestHistories.vue?vue&type=template&id=baaf0764&"
import script from "./ReportCallRequestHistories.vue?vue&type=script&lang=js&"
export * from "./ReportCallRequestHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports